import { apiGetAuth, apiPostAuth, apiPutAuth, apiGetAuthWithCustomHeadersResponseType } from '@/utils/api'
import { API_REPORT_ORDER, API_STORE, API_ORDER_MANAGEMENT } from '@/utils/api-url'
import { notificationDanger, notificationSuccess } from '@/utils/notification'
import { exportCustomHeaderAndResponseType } from '@/utils/helper'

const state = () => {
  return {
    order: { data: [] },
    order_item: { data: [] },
    detail_order: { data: [] },
    store: { data: [] },
    order_type: { data: [] },
    preview: { data: [] },
    data_modal_add_edit: {},
    meta_filter: {},
    list_cancel_reason: { data: [] },
    toggle_modal_add_edit_discard: {
      targetModals: false,
      title: '',
      description: '',
      customTitleBtnOk: '',
      customClass: '',
      type: '',
      loadingTable: false,
      loadingPopUp: false
    },
    toggle_modal_export: {
      targetModals: false,
      title: '',
      message: '',
      buttonText: '',
      loading: false
    }
  }
}

const mutations = {
  SET_ORDER(state, payload) {
    state.order = payload
  },
  SET_ORDER_ITEM(state, payload) {
    state.order_item = payload
  },
  SET_DETAIL_ORDER(state, payload) {
    state.detail_order = payload
  },
  SET_STORE(state, payload) {
    state.store = payload
  },
  SET_ORDER_TYPE(state, payload) {
    state.order_type = payload
  },
  SET_ORDER_PREVIEW(state, payload) {
    state.preview = payload
  },
  SET_DATA_MODAL_ADD_EDIT(state, payload) {
    state.data_modal_add_edit = payload
  },
  SET_TOGGLE_MODAL_ADD_EDIT_DISCARD(state, payload) {
    state.toggle_modal_add_edit_discard = payload
  },
  SET_META_FILTER(state, payload) {
    state.meta_filter = payload
  },
  SET_LIST_CANCEL_REASON(state, payload) {
    state.list_cancel_reason = payload
  },
  SET_TOGGLE_MODAL_EXPORT(state, payload) {
    state.toggle_modal_export = payload
  }
}

const actions = {
  async getListOrder(context, payload) {
    try {
      const apiParams = { ...payload }
      if (apiParams.date_from && !apiParams.order_date_from) {
        apiParams.order_date_from = apiParams.date_from
      }
      delete apiParams.date_from

      if (apiParams.date_until && !apiParams.order_date_until) {
        apiParams.order_date_until = apiParams.date_until
      }
      delete apiParams.date_until

      delete apiParams.order_date_range
      delete apiParams.refund_date_range

      const queryParams = new URLSearchParams()
      Object.entries(apiParams).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          queryParams.append(key, value.toString())
        }
      })

      const response = await apiGetAuth(API_REPORT_ORDER.LIST_ORDER, apiParams)

      context.commit('SET_ORDER', response.data.data)
      const meta = { ...payload, store_code: payload?.store_code?.includes(",") ? undefined : payload?.store_code }
      context.commit('SET_META_FILTER', meta)

      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  },
  async exportOrder(context, payload) {
    try {
      const apiParams = { ...payload }
      if (apiParams.date_from && !apiParams.order_date_from) {
        apiParams.order_date_from = apiParams.date_from
      }
      delete apiParams.date_from

      if (apiParams.date_until && !apiParams.order_date_until) {
        apiParams.order_date_until = apiParams.date_until
      }
      delete apiParams.date_until

      delete apiParams.order_date_range
      delete apiParams.refund_date_range

      const response = await apiGetAuth(API_REPORT_ORDER.EXPORT_ORDER, apiParams)
      if(response?.status == 200) {
        context.commit('SET_TOGGLE_MODAL_EXPORT', {
          targetModals: true,
          title: 'Export Requested',
          message: response.data.message || 'Mohon tunggu, Link download file akan dikirim ke email anda',
          buttonText: 'OK',
          loading: false
        })
        notificationSuccess("Export Requested")
      }
    } catch (error) {
      notificationDanger(error)
      throw error
    }
  },
  async getDetailOrder(context, payload) {
    try {
      const response = await apiGetAuth(API_REPORT_ORDER.DETAIL_ORDER(payload))
      context.commit('SET_DETAIL_ORDER', response.data.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getListOrderItem(context, payload) {
    try {
      const response = await apiGetAuth(API_REPORT_ORDER.LIST_ORDER_ITEM(payload.id), payload.reqBody)
      context.commit('SET_ORDER_ITEM', response.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getListStore(context, payload) {
    try {
      const response = await apiGetAuth(API_STORE.LIST_STORE, payload)
      context.commit('SET_STORE', response.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getListOrderType(context) {
    try {
      const response = await apiGetAuth(API_ORDER_MANAGEMENT.LIST_ORDER_TYPE)
      context.commit('SET_ORDER_TYPE', response.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getListCancelReason(context) {
    try {
      const response = await apiGetAuth(API_ORDER_MANAGEMENT.GET_LIST_CANCEL_REASON)

      context.commit('SET_LIST_CANCEL_REASON', response.data)

      return response.data
    } catch (error) {
      console.error('Error fetching cancel reasons:', error)
      notificationDanger(error)
    }
  },
  async getOrderPreview(context, payload) {
    try {
      const response = await apiGetAuth(API_ORDER_MANAGEMENT.PREVIEW_ORDER(payload))
      context.commit('SET_ORDER_PREVIEW', response.data.data)
    } catch (error) {
      notificationDanger(error)
    }
  },

  async getExportRecapDetailTransaction(context, payload) {
    try {
      const modifiedPayload = { ...payload }

      modifiedPayload.date_from = modifiedPayload.date_from || ''
      modifiedPayload.date_until = modifiedPayload.date_until || ''

      if (modifiedPayload.date_from?.includes('+')) {
        modifiedPayload.date_from = modifiedPayload.date_from.replace(/\+/g, ' ')
      }

      if (modifiedPayload.date_until?.includes('+')) {
        modifiedPayload.date_until = modifiedPayload.date_until.replace(/\+/g, ' ')
      }

      let url = API_REPORT_ORDER.EXPORT_ORDER_DETAILS + '?'
      const queryParts = []

      let orderedParams = [
        'order_id',
        'store_code',
        'date_from',
        'date_until',
        'page',
        'limit',
        'report'
      ]

      if (modifiedPayload.report === 'unpick') {
        orderedParams.splice(4, 0, 'unpick_reason')
      }

      orderedParams.forEach(key => {
        if (key === 'date_from' || key === 'date_until') {
          queryParts.push(`${key}=${encodeURIComponent(modifiedPayload[key] || '')}`)
        }
        else if (key === 'store_code' && modifiedPayload[key]) {
          queryParts.push(`${key}=${modifiedPayload[key]}`)
        }
        else if (key in modifiedPayload && modifiedPayload[key] !== undefined && modifiedPayload[key] !== null) {
          queryParts.push(`${key}=${encodeURIComponent(modifiedPayload[key])}`)
        }
      })
      url += queryParts.join('&')

      const response = await apiGetAuth(url)

      return response
    } catch (error) {
      notificationDanger(error)
      throw error
    }
  },
  async getExportRecapDisbursement(context, payload) {
    try {
      const today = new Date()
      const dd = String(today.getDate()).padStart(2, '0')
      const mm = String(today.getMonth() + 1).padStart(2, '0')
      const yyyy = today.getFullYear()

      const modifiedPayload = { ...payload, report: 'disbursement' }

      modifiedPayload.date_from = modifiedPayload.date_from || ''
      modifiedPayload.date_until = modifiedPayload.date_until || ''

      if (modifiedPayload.date_from && modifiedPayload.date_from.includes('+')) {
        modifiedPayload.date_from = modifiedPayload.date_from.replace(/\+/g, ' ')
      }

      if (modifiedPayload.date_until && modifiedPayload.date_until.includes('+')) {
        modifiedPayload.date_until = modifiedPayload.date_until.replace(/\+/g, ' ')
      }

      let url = API_REPORT_ORDER.EXPORT_DISBURSEMENT + '?'
      const queryParts = []

      const orderedParams = [
        'order_id',
        'store_code',
        'date_from',
        'date_until',
        'page',
        'limit',
        'report'
      ]

      orderedParams.forEach(key => {
        if (key === 'date_from' || key === 'date_until') {
          queryParts.push(`${key}=${encodeURIComponent(modifiedPayload[key] || '')}`)
        }
        else if (key === 'store_code' && modifiedPayload[key]) {
          queryParts.push(`${key}=${modifiedPayload[key]}`)
        }
        else if (key in modifiedPayload && modifiedPayload[key] !== undefined && modifiedPayload[key] !== null) {
          queryParts.push(`${key}=${encodeURIComponent(modifiedPayload[key])}`)
        }
      })

      url += queryParts.join('&')

      const response = await apiGetAuthWithCustomHeadersResponseType(url)
      exportCustomHeaderAndResponseType(response.data, `DisbursementReport_${yyyy}${mm}${dd}.xlsx`)
      return response
    } catch (error) {
      notificationDanger(error)
      throw error
    }
  },
  async getUnpickOrder(context, payload) {
    try {
      const apiParams = { ...payload }

      apiParams.report = 'unpick'

      apiParams.date_from = apiParams.date_from || ''
      apiParams.date_until = apiParams.date_until || ''

      if (apiParams.date_from && apiParams.date_from.includes('+')) {
        apiParams.date_from = apiParams.date_from.replace(/\+/g, ' ')
      }

      if (apiParams.date_until && apiParams.date_until.includes('+')) {
        apiParams.date_until = apiParams.date_until.replace(/\+/g, ' ')
      }

      const orderedParams = [
        'order_id',
        'store_code',
        'date_from',
        'date_until',
        'unpick_reason',
        'page',
        'limit',
        'report'
      ]

      const queryParts = []
      orderedParams.forEach(key => {
        if (key in apiParams) {
          queryParts.push(`${key}=${encodeURIComponent(apiParams[key])}`)
        }
      })

      const response = await apiGetAuth(API_REPORT_ORDER.ORDER_DETAILS, apiParams)

      context.commit('SET_ORDER', response.data.data)
      context.commit('SET_META_FILTER', apiParams)
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getOrderDetails(context, payload) {
    try {
      const apiParams = { ...payload }

      apiParams.date_from = apiParams.date_from || ''
      apiParams.date_until = apiParams.date_until || ''

      if (apiParams.date_from && apiParams.date_from.includes('+')) {
        apiParams.date_from = apiParams.date_from.replace(/\+/g, ' ')
      }

      if (apiParams.date_until && apiParams.date_until.includes('+')) {
        apiParams.date_until = apiParams.date_until.replace(/\+/g, ' ')
      }

      const orderedParams = [
        'order_id',
        'store_code',
        'date_from',
        'date_until',
        'page',
        'limit',
        'report'
      ]

      const queryParts = []
      orderedParams.forEach(key => {
        if (key in apiParams) {
          queryParts.push(`${key}=${encodeURIComponent(apiParams[key])}`)
        }
      })

      const response = await apiGetAuth(API_REPORT_ORDER.ORDER_DETAILS, apiParams)

      context.commit('SET_ORDER', response.data.data)
      context.commit('SET_META_FILTER', apiParams)
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getDisbursement(context, payload) {
    try {
      const apiParams = { ...payload }

      apiParams.report = ''

      apiParams.date_from = apiParams.date_from || ''
      apiParams.date_until = apiParams.date_until || ''

      if (apiParams.date_from && apiParams.date_from.includes('+')) {
        apiParams.date_from = apiParams.date_from.replace(/\+/g, ' ')
      }

      if (apiParams.date_until && apiParams.date_until.includes('+')) {
        apiParams.date_until = apiParams.date_until.replace(/\+/g, ' ')
      }

      const orderedParams = [
        'order_id',
        'store_code',
        'date_from',
        'date_until',
        'page',
        'limit',
        'report'
      ]

      const queryParts = []
      orderedParams.forEach(key => {
        if (key in apiParams) {
          queryParts.push(`${key}=${encodeURIComponent(apiParams[key])}`)
        }
      })

      const response = await apiGetAuth(API_REPORT_ORDER.GET_DISBURSEMENT, apiParams)

      context.commit('SET_ORDER', response.data.data)
      context.commit('SET_META_FILTER', apiParams)
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  },

  async getNewDriver(context, payload) {
    try {
      const response = await apiPostAuth(API_ORDER_MANAGEMENT.GET_NEW_DRIVER(payload))
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,
        title: '',
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async updateUnpickAll(context, payload) {
    try {
      const response = await apiPutAuth(API_ORDER_MANAGEMENT.UPDATE_UNPICK_ALL(payload))
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,
        title: '',
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async putOrderItemsUpdate(context, payload) {
    try {
      const response = await apiPutAuth(API_ORDER_MANAGEMENT.UPDATE_ORDER_ITEMS(payload.id), payload.data)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,
        title: '',
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  }
}

const getters = {
  list_order(state) {
    return state.order
  },
  list_order_item(state) {
    return state.order_item
  },
  detail_order(state) {
    return state.detail_order
  },
  list_store(state) {
    return state.store
  },
  order_type(state) {
    return state.order_type
  },
  preview(state) {
    return state.preview
  },
  get_toggle_modal_add_edit_discard(state) {
    return state.toggle_modal_add_edit_discard
  },
  get_data_modal_add_edit(state) {
    return state.data_modal_add_edit
  },
  meta_filter(state) {
    return state.meta_filter
  },
  list_cancel_reason(state) {
    return state.list_cancel_reason
  },
  get_toggle_modal_export(state) {
    return state.toggle_modal_export
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
